import React, { Component } from "react";
import PropTypes from 'prop-types';
import {answerBubbleStyle, answerBubbleStyleMobile} from '../../utils/styles';

class SelfieModeIsSelect extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
        showText: this.props.showText,
        submitted: false,

    }
  }

  componentDidMount(){
     // 进度条
     try {
      if(this.props.fun_updateStage){
        var stage = this.props.stage;
        var stageSum = this.props.stageSum;
        if(stage && stageSum)
        this.props.fun_updateStage(parseInt(stage)-1,stageSum);
      }
    } catch (error) {
      console.error(error);
    }
    
  }


  handleSubmit(type,text){
    this.setState({ submitted: true });
    this.props.step.value = {value: type, label: text};

    try {
      if(this.props.fun_updateStage){
        var stage = this.props.stage;
        var stageSum = this.props.stageSum;
        if(stage && stageSum)
        this.props.fun_updateStage(stage,stageSum);
      }
    } catch (error) {
      console.error(error);
    }

    this.props.triggerNextStep({
      value: {value: type, label: text}
    });
  }

  render() {
    if (this.state.submitted) {
      return (
      <div className="onb-item-container">
        <div className="onb-text-conten">{this.state.showText}</div>
      </div>
      );
    }
    return (
            <div className="onb-item-container">
              <div className="onb-text-conten">{this.state.showText}</div>
              <div className="conten-wrap selfie-zone">
                <button className="p-a-n-button" onClick={()=>this.handleSubmit(1,'Sure')}>Sure</button>
                <button className="p-a-n-button" onClick={()=>this.handleSubmit(2,'Pass')}>Pass</button>
              </div>
            </div>
    );
  }
}

SelfieModeIsSelect.propTypes = {
  steps: PropTypes.object,
};

SelfieModeIsSelect.defaultProps = {
  steps: undefined,
};

export default SelfieModeIsSelect;



// WEBPACK FOOTER //
// ./src/views/onboardingAA/SelfieModeIsSelect.js